define([
    'text!product-detail/component/knowledge-tabs.html',
    'product-detail/component/knowledge-tab-item',
    'product-detail/mixin/product',

    'css!product-detail/component/knowledge-tabs.css'
], function(
    tpl,
    KnowledgeTabItem,
    ProductMixin
){
    return {
        template: tpl,
        components: {
            KnowledgeTabItem: KnowledgeTabItem
        },
        mixins: [ProductMixin],
        props: {
            list: {
                type: Array
            }
        },
        data: function(){
            return {
                selectedIndex: -1
            };
        },
        computed: {
            selectedItem: function(){
                return this.list[this.selectedIndex] || null;
            },
            selectedDesc: function(){
                if (!this.selectedItem) return '';
                return this.spuBase[this.selectedItem.field] || '';
            }
        },
        methods: {
            selectItem: function(index){
                if (index === this.selectedIndex){
                    this.selectedIndex = -1;
                } else {
                    this.selectedIndex = index;
                }
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/knowledge-tabs.js
// module id = 107
// module chunks = 0